import { Calendar } from "ant-design-vue";
const { ...other } = Calendar;
const YwCalendar = {
	...other,
	name: "YwCalendar",
};

YwCalendar.install = function (Vue) {
	Vue.component(YwCalendar.name, Calendar);
};

export default YwCalendar;
